import { parseWorkflowCondition } from '../../server/workflow-rules';

export function WorkflowConditionEditor({
  trigger,
  value,
  onChange,
}: {
  trigger: string;
  value: string;
  onChange: (value: string) => void;
}) {
  const rule = parseWorkflowCondition(value, trigger);
  const scoreDraft = /^(?:BOS|score)\s*(>=|<=|!=|>|<|=|≥|≤)\s*(\d*)$/i.exec(value);
  const score = rule?.kind === 'score' || (scoreDraft && trigger !== 'PropertyAvailabilityChanged');
  const special =
    trigger === 'SiteVisitScheduled'
      ? 'Every scheduled visit'
      : trigger === 'TaskOverdue'
        ? 'Overdue by 24 hours'
        : trigger === 'PropertyAvailabilityChanged'
          ? 'Published and available inventory'
          : '';
  const mode = score ? 'score' : rule ? value : 'unsupported';
  return (
    <fieldset style={{ border: 0, padding: 0, margin: '0 0 16px' }}>
      <legend>Condition</legend>
      <select
        className="input"
        aria-label="Workflow condition"
        value={mode}
        onChange={(e) => onChange(e.target.value === 'score' ? 'BOS >= 70' : e.target.value)}
      >
        {!rule && !score && (
          <option value="unsupported" disabled>
            Unsupported saved condition — choose a rule
          </option>
        )}
        <option value="All matching records">All matching records</option>
        {trigger !== 'PropertyAvailabilityChanged' && (
          <option value="score">Buyer score comparison</option>
        )}
        {special && <option value={special}>{special}</option>}
      </select>
      {score && (
        <div className="form-grid" style={{ marginTop: 10 }}>
          <label className="field">
            <span>Comparison</span>
            <select
              className="input"
              aria-label="Score comparison"
              value={rule?.kind === 'score' ? rule.operator : scoreDraft?.[1] || '>='}
              onChange={(e) => onChange(`BOS ${e.target.value} ${scoreDraft?.[2] || '70'}`)}
            >
              {[
                ['>=', 'At least'],
                ['>', 'Above'],
                ['<=', 'At most'],
                ['<', 'Below'],
                ['=', 'Exactly'],
                ['!=', 'Different from'],
              ].map(([operator, label]) => (
                <option key={operator} value={operator}>
                  {label}
                </option>
              ))}
            </select>
          </label>
          <label className="field">
            <span>Score (0–100)</span>
            <input
              className="input"
              type="number"
              aria-label="Score threshold"
              min={0}
              max={100}
              step={1}
              required
              value={scoreDraft?.[2] || ''}
              onChange={(e) =>
                onChange(
                  `BOS ${rule?.kind === 'score' ? rule.operator : scoreDraft?.[1] || '>='} ${e.target.value}`,
                )
              }
            />
          </label>
        </div>
      )}
      {!rule && (
        <p role="alert" className="ops-help">
          This condition cannot run. Choose a supported rule and a whole-number score from 0 to 100.
        </p>
      )}
      <p className="ops-help">
        Score rules use the linked buyer’s current score. Suppressed buyers are excluded. Overdue
        workflows wait 24 hours and exclude automation-created tasks.
      </p>
    </fieldset>
  );
}
